import { render, staticRenderFns } from "./PaybackPoints.vue?vue&type=template&id=61f151f0&scoped=true"
import script from "./PaybackPoints.vue?vue&type=script&lang=js"
export * from "./PaybackPoints.vue?vue&type=script&lang=js"
import style0 from "./PaybackPoints.vue?vue&type=style&index=0&id=61f151f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f151f0",
  null
  
)

export default component.exports